import { APP_NAME } from '@/common/constants';

let monitorConfigUpdated = false;

export const initMonitor = () => {
  if (!window.__MONITOR__ || monitorConfigUpdated) {
    return;
  }
  window.__MONITOR__.updateConfig({
    path: window.location.href,
    debounceSeconds: 1,
    appName: APP_NAME,
  });
  monitorConfigUpdated = true;
};

export const track = (desc = '', action = 'load') => {
  window.__MONITOR__?.tracking({
    label: 'One Page Checkout',
    desc,
    action,
  });
};
